import { io } from 'socket.io-client';

import socketBaseUrl from './socketBaseUrl';

const ordersSyncSocket = io(`${socketBaseUrl}/orders-sync-progress`, {
  transports: ['websocket'],
  autoConnect: false,
});

export default ordersSyncSocket;
